module.exports = __webpack_public_path__ + "img/icc-t20-world-cup-logo-default.6043cfea.png";